module.exports = __webpack_public_path__ + "63e1f4cfc2af041e263c3c14aa5299d0.svg";